import { ReactElement, useState } from 'react'
import { AsyncThunkAction, AsyncThunkConfig } from '@reduxjs/toolkit'
import { useNavigate } from 'react-router-dom'

import axios, { pluckError } from 'src/utilities/http-client'
import { CloseIcon, ConfirmIcon } from 'src/v3/core/icons'
import { useAppDispatch } from 'src/store/hooks'

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
} from '@mui/material'
import { useNotifications } from 'src/v3/hooks/use-notifications'

type Props = {
  name: string
  extraText?: string
  route: string
  fetchEntity: AsyncThunkAction<any, any, AsyncThunkConfig>[]
  navigateURL?: string
  open: boolean
  setOpen: (status: boolean) => void
}

export let ConfirmDeletion = ({
  name,
  extraText,
  route,
  fetchEntity,
  navigateURL,
  open,
  setOpen,
}: Props): ReactElement => {
  let dispatch = useAppDispatch()
  let navigate = useNavigate()
  let { showError, NotificationComponent } = useNotifications()

  let [saving, setSaving] = useState(false)

  let handleOnClose = () => {
    setOpen(false)
  }

  return (
    <Dialog open={open} onClose={handleOnClose}>
      <Paper sx={{ width: 'fit-content', px: 2, py: 1, maxWidth: 320 }}>
        <DialogTitle
          sx={{ color: 'textSecondary', textAlign: 'center', mb: -1 }}
        >
          Confirm Deletion
        </DialogTitle>
        <DialogContent sx={{ px: 2, pb: 1 }}>
          Are you sure you want to delete this {name}? {extraText}
        </DialogContent>
        <DialogActions
          sx={{
            display: 'flex',
            justifyContent: 'center',
            pb: 1.5,
          }}
        >
          <Button
            color="primary"
            variant="contained"
            sx={{ flex: '1 1 0px' }}
            startIcon={<ConfirmIcon />}
            loading={saving}
            onClick={() => {
              setSaving(true)
              axios
                .delete(route)
                .then(() =>
                  Promise.all(fetchEntity.map((entity) => dispatch(entity))),
                )
                .then(() =>
                  !navigateURL ? setOpen(false) : navigate(navigateURL),
                )
                .catch((err) => showError(pluckError(err)))
                .finally(() => setSaving(false))
            }}
          >
            Confirm
          </Button>
          <Button
            color="error"
            onClick={handleOnClose}
            variant="contained"
            sx={{ flex: '1 1 0px' }}
            startIcon={<CloseIcon />}
          >
            Cancel
          </Button>
        </DialogActions>
        {NotificationComponent}
      </Paper>
    </Dialog>
  )
}
